import { createFileRoute } from "@tanstack/react-router";
import CallbackPage from "@/components/navigation/CallbackPage";

export const Route = createFileRoute("/callback")({
  component: CallbackPage,
});
